import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import cn from 'classnames';
import { Bulb, CloseCrossCircle, Danger } from '../../icons';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { FullRow } from '../Layout';
import { Typography } from '../Typography';
import styles from './Callout.module.scss';
const IsInCalloutContext = /*#__PURE__*/ React.createContext(false);
export const useIsInCallout = ()=>useContext(IsInCalloutContext);
const iconsMap = {
    info: /*#__PURE__*/ _jsx(Bulb, {
        size: 18
    }),
    warning: /*#__PURE__*/ _jsx(Danger, {
        size: 18
    }),
    error: /*#__PURE__*/ _jsx(CloseCrossCircle, {
        size: 18
    })
};
export function Callout(props) {
    const { intent = 'info', icon, footer, withAction, className, children, weight, variant, hideIcon, withBorder, testId, classes, isMobile } = props, rest = _object_without_properties(props, [
        "intent",
        "icon",
        "footer",
        "withAction",
        "className",
        "children",
        "weight",
        "variant",
        "hideIcon",
        "withBorder",
        "testId",
        "classes",
        "isMobile"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const effectiveIsMobileDevice = isMobile !== null && isMobile !== void 0 ? isMobile : isMobileDevice || isInBottomSheet;
    const shouldHideIcon = hideIcon !== null && hideIcon !== void 0 ? hideIcon : effectiveIsMobileDevice;
    const effectiveWithBorder = withBorder !== null && withBorder !== void 0 ? withBorder : effectiveIsMobileDevice;
    return /*#__PURE__*/ _jsx(IsInCalloutContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
            className: cn(styles.root, styles[intent], {
                [styles.border]: effectiveWithBorder,
                [styles.mobile]: effectiveIsMobileDevice
            }, classes === null || classes === void 0 ? void 0 : classes.wrapper, className),
            "data-testid": testId
        }, rest), {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.main, classes === null || classes === void 0 ? void 0 : classes.main),
                    children: [
                        !shouldHideIcon && /*#__PURE__*/ _jsx("div", {
                            className: styles.icon,
                            children: icon || iconsMap[intent]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            className: styles.content,
                            weight: weight,
                            variant: variant,
                            children: children
                        }),
                        !effectiveIsMobileDevice && withAction
                    ]
                }),
                effectiveIsMobileDevice && withAction && /*#__PURE__*/ _jsx(FullRow, {
                    gap: 8,
                    alignItems: "center",
                    className: styles.actionRow,
                    children: withAction
                }),
                footer && /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.footer, classes === null || classes === void 0 ? void 0 : classes.footer),
                    children: footer
                })
            ]
        }))
    });
}
